import * as types from './mutation-types'

export default {
    [types.SET_STEP](state, step) {
        state.step = step
    },
    [types.SET_CURRENTCOMPONENT](state, currentComponent) {
        state.currentComponent = currentComponent
    },
    [types.SET_NEGOTIABLE](state, contract) {
        state.contractNegotiable = [];
        state.contractNegotiable = contract
    },
    [types.SET_NEGOTIABLE_OPTIONS](state, contract) {
        state.contractNegotiableOptions = [];
        state.contractNegotiableOptions = contract
    },
    [types.SET_PARCELAMNENT_SELECTED](state, select) {
        state.parcelamentSelected = null;
        state.parcelamentSelected = select
    },
    [types.SET_RESUME](state, resume) {
        state.agreementResume = null;
        state.agreementResume = resume;
    },
    [types.SET_DIVIDAS](state, dividas) {
        state.dividas = dividas
    },
    [types.SET_BOLETO_EXPRESSO](state, boletos) {
        state.boletos = boletos
    },
    [types.SET_NEGOCIACAO](state, deal) {
        state.negociacao = deal
    },
    [types.SET_ACORDO](state, acordo) {
        state.acordo = acordo
    },
}